export const windowFullWidth = window.innerWidth;
export const windowHeight = window.innerHeight + window.outerHeight;
